const BASE_URL = process.env.REACT_APP_API_BASE_URL;

/**
 * Fetch paginated + searchable patient list.
 * @param {number} page    - page number (1-based)
 * @param {string} search  - optional search string
 * @param {AbortSignal} signal
 */
export async function fetchPatients(page = 1, search = "", signal) {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("auth token missing");

  const params = new URLSearchParams({ page });
  if (search.trim()) params.append("search", search.trim());

  const res = await fetch(
    `${BASE_URL}/api/list/patients?${params}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      signal,
    }
  );

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.message || `Request failed with status ${res.status}`);
  }

  const json = await res.json();
  if (json.status !== "success") throw new Error(json.message || "Unknown error");

  // normalise: return { patients, page, totalPages, total }
  const d = json.data;
  return {
    patients:   d.data,
    page:       d.page,
    totalPages: d.total_pages,
    total:      d.total,
  };
}